import angular from 'angular';

/* @ngInject */
const ktranslateDirective = (
	/** @type {import('angular').ITimeoutService} */ $timeout,
	/** @type {any} */ KTranslate,
) => ({
	restrict: 'A',
	scope:    {
		ktranslate: '=',
		text:       '=?',
	},
	/**
	 * @param {any} scope
	 * @param {any} element
	 */
	link(scope, element) {
		scope.text = '';
		$timeout(() => {
			scope.$watch('ktranslate', async (
				/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */ kid,
				/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */ oldKid,
			) => {
				if (kid && kid.startsWith('K_NODE;')) {
					if (element.text() === '' || (oldKid && kid !== oldKid)) {
						try {
							scope.text = await KTranslate.request(scope, kid);
						}
						catch {
							scope.text = '';
						}
					}
					else {
						scope.text = element.text();
						KTranslate.set(scope, kid, element.text());
					}
				}
			});
		});

		scope.$watch('text', (/** @type {any} */ text, /** @type {any} */ oldText) => {
			if (text && text !== oldText) {
				element.text(text);
			}
		});

		scope.$on('$destroy', () => {
			KTranslate.remove(scope.$id);
		});
	},
});

angular.module('app')
	.directive('ktranslate', ktranslateDirective);
